import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DocumentTitle from '../../components/DocumentTitle';
import __ from '../../helpers/translation';
import FormError from '../../components/partials/FormError';
import api from '../../actions/api';
import { destructServerErrors, hasError, getError } from '../../helpers/error';

class ForgotPassword extends Component {
  constructor (props) {
    super(props);
    this.state = {
      'email': '',
      'errors': '',
      'resetMessage': ''
    };
  }

  handleSubmit (e) {
    e.preventDefault();
    window.axios.post(api.password.email, { email: this.state.email })
      .then(({ data: { status } }) => {
        this.setState({ 'resetMessage': status });
      }).catch(error => {
        this.setState({ errors: destructServerErrors(error) });
      });
  }

  handleInputChange (e) {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {
        ...this.state.errors,
        ...{ [e.target.name]: '' }
      }
    });
  }

  componentDidMount () {
    document.body.classList.add('bg-green-gradient','d-flex', 'flex-column', 'mh-100vh', 'justify-content-center');
  }

  componentWillUnmount () {
    document.body.classList.remove(... document.body.classList);
  }

  render () {
    document.body.classList.add('bg-green-gradient','d-flex', 'flex-column', 'mh-100vh', 'justify-content-center');

    return (
      <DocumentTitle title={`${__('app.forgot_password.title')} - ${window.App.name}`}>

          <div className="container">
              <div className="row">
                  <div className="col-md-6 offset-md-3 col-12">
                      <h2 className="text-white">{ __('app.forgot_password.title') }</h2>
                      {
                        this.state.resetMessage !== '' && (
                        <div className="alert alert-info font-size-18 font-weight-bold" role="alert">
                          {this.state.resetMessage}
                        </div>
                        )
                      }
                      <p className="text-white font-size-18 my-4">{ __('app.forgot_password.description') }</p>
                      <form onSubmit={e => this.handleSubmit(e)} method="POST">
                          <div className="form-label-group">
                              <input
                                value={this.state.email}
                                onChange={e => this.handleInputChange(e)}
                                id="email"
                                type="email"
                                name="email"
                                className={`form-control ${hasError(this.state.errors, 'email') ? 'border-orange' : ''}`}
                                placeholder={ __('app.forgot_password.email') } 
                                required
                                autoFocus
                              />
                              <label htmlFor="email">{ __('app.forgot_password.email') }</label>
                              {
                                hasError(this.state.errors, 'email') &&
                                <div className="mt-3">
                                  <FormError>{getError(this.state.errors, 'email')}</FormError>
                                </div>
                              }
                          </div>
                          <input type="submit" className="btn btn-black d-block w-100 light-shadow mb-3" value={ __('app.forgot_password.button') } />
                          <Link to="/" className="btn btn-link text-white text-center w-100">{ __('app.forgot_password.to_login') }</Link>
                      </form>
                  </div>
              </div>
          </div>

      </DocumentTitle>
    );
  }
}

export default ForgotPassword;
